<script setup lang="ts">
  const model = defineModel<string | undefined>()

  function onInput(event: Event) {
    const target = event.target as HTMLInputElement
    model.value = target.value
  }
</script>

<template>
  <label class="color-picker">
    <span class="color-picker__swatch" :style="{ backgroundColor: model }">
      <input type="color" :value="model" class="color-picker__input" @input="onInput" />
    </span>
  </label>
</template>

<style scoped lang="css">
  .color-picker {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    border: 1px solid var(--colours-grey-2);
    border-radius: 6px;
  }

  .color-picker__swatch {
    width: var(--spacing-m);
    height: var(--spacing-m);
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .color-picker__input {
    width: 100%;
    height: 100%;
    border: none;
    padding: 0;
    cursor: pointer;
    background: none;
  }

  .color-picker__input::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  .color-picker__input::-webkit-color-swatch {
    border: none;
  }
</style>
